import { useLocation } from 'react-router-dom';

interface ReturnPath {
  pathname: string;
  search: string;
  hash: string;
}

interface ReturnLocationState {
  from?: ReturnPath;
}

export function useLoginReturnState(): ReturnLocationState {
  const location = useLocation();

  return {
    from: {
      pathname: location.pathname,
      search: location.search,
      hash: location.hash,
    },
  };
}

export function useReturnPath(fallback: string): string {
  const location = useLocation();
  const from = (location.state as ReturnLocationState | null)?.from;

  if (!from?.pathname || !isSafeInternalPath(from.pathname)) {
    return fallback;
  }

  return `${from.pathname}${from.search ?? ''}${from.hash ?? ''}`;
}

function isSafeInternalPath(pathname: string): boolean {
  return pathname.startsWith('/') && !pathname.startsWith('//');
}
